export default __webpack_public_path__ + "static/media/twitter icon.c73011ac.svg";